import { keyBy } from "lodash";

import { People } from "@livechat/design-system-icons";

import { IAgentFilterItem } from "../agent-filter";
import { IFilterConfig, IFilterLabelValue } from "../interfaces";

const title = "Followers";
export const followersFilterConfig: IFilterConfig = {
  title,
  icon: People,
  mobileViewTitle: "Select followers",
  multiple: true,
  getFilterLabelValues: (filterValues: string[] | null, agents: IAgentFilterItem[]): IFilterLabelValue[] => {
    if (filterValues === null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    const agentsMap = keyBy(agents, agent => agent.id);
    return filterValues.reduce((acc: IFilterLabelValue[], followerID) => {
      if (followerID === "ME") {
        return [...acc, { key: "ME", label: "Logged in agent" }];
      }

      if (agentsMap[followerID]) {
        return [...acc, { key: agentsMap[followerID].id, label: agentsMap[followerID].name }];
      }

      return [...acc, { key: followerID, label: "Follower removed", invalid: true }];
    }, []);
  },
};
